export const ENDPOINT = {
    LOGIN_CHECK: '/auth/verify',

    WORK_CENTER_LIST: '/workcenter/list',
    WORK_CENTER_ADD: '/workcenter/add',
    WORK_CENTER_UPDATE: '/workcenter/update',
    WORK_CENTER_LIST_BY_ID: '/workcenter/listbyid',

    OPERATIONS_LIST: '/operation/list',
    OPERATIONS_ADD: '/operation/add',
    OPERATIONS_UPDATE: '/operation/update',
    OPERATIONS_LIST_BY_ID: '/operation/listbyid',

    PARTS_LIST: '/parts/list',
    PARTS_ADD: '/parts/add',
    PARTS_UPDATE: '/parts/update',
    PARTS_LIST_BY_ID: '/parts/listbyid',

    WORKFLOWS_LIST: '/workflow/list',
    WORKFLOWS_ADD: '/workflow/add',
    WORKFLOWS_UPDATE: '/workflow/update',
    WORKFLOWS_LIST_BY_ID: '/workflow/listbyid',
    WORKFLOWS_BY_ORDER: '/workflow/by-order',

    JOB_LIST: '/job/list',
    JOB_ADD: '/job/add',
    JOB_UPDATE: '/job/update',
    JOB_LIST_BY_ID: '/job/listbyid',
    /** Base: GET `/job/guided/:jobId/:stepIndex`, PATCH checklist, POST complete-setup */
    JOB_GUIDED: '/job/guided',

    TASK_LIST: '/task/list',
    TASK_ADD: '/task/add',
    TASK_UPDATE: '/task/update',
    TASK_LIST_BY_ID: '/task/listbyid',

    OPERATOR_LIST: '/operator/list',
    OPERATOR_ADD: '/operator/add',
    OPERATOR_UPDATE: '/operator/update',
    OPERATOR_LIST_BY_ID: '/operator/listbyid',

    SKILL_LIST: '/skill/list',
    SKILL_ADD: '/skill/add',

    MACHINE_TYPE_LIST: '/machine-type/list',
    MACHINE_CAPABILITIES_CATALOG: '/machine/onboarding/capabilities-catalog',
    MACHINE_CATALOG_BRANDS: '/machine/onboarding/catalog/brands',
    MACHINE_CATALOG_MODELS: '/machine/onboarding/catalog/models',

    MATERIAL_CATALOG_CATEGORIES: '/catalog/material-categories',
    MATERIAL_CATALOG_GRADES: '/catalog/material-grades',
    RECIPE_SAVE: '/recipe/save',
    RECIPE_PROCESS_PARAMETER_GROUPS: '/recipe/process-parameter-groups',
    RECIPE_LIST: '/recipe/list',
    RECIPE_LIST_BY_ID: '/recipe/listbyid',
    RECIPE_DELETE: '/recipe',
    RECIPE_WORK_INSTRUCTIONS: '/recipe/workinstructions',
    RECIPE_WORK_INSTRUCTIONS_REORDER: '/recipe/workinstructions/reorder',
    RECIPE_QUALITY_SPECS: '/recipe/qualityspecs',

    DASHBOARD_SUMMARY: '/dashboard/summary',

    ORDER_PARTS_LIST: '/orderparts/list',
    ORDER_PARTS_LIST_BY_ORDER: '/orderparts/listbyorder',
    ORDER_PARTS_ADD: '/orderparts/add',
    ORDER_PARTS_UPDATE: '/orderparts/update',
    ORDER_PARTS_LIST_BY_ID: '/orderparts/listbyid',

    /** Base path for `/orders/:id/cad-upload` etc. */
    ORDERS_BASE: '/orders',
    ORDER_LIST: '/orders/list',
    ORDER_LIST_BY_ID: '/orders/listbyid',
    ORDER_ADD: '/orders/add',
    ORDER_UPDATE: '/orders/update',

    CLIENT_LIST: '/client/list',
    CLIENT_ADD: '/client/add',

    /** Proxied Partner API: active vendor / platform purchase orders */
    PARTNER_VENDOR_ACTIVE_POS: '/partner/vendor-orders/active-pos',
    /** Proxied Partner API: single PO / vendor order by id (see PARTNER_VENDOR_ORDER_DETAIL_PATH on server) */
    PARTNER_VENDOR_ORDER: '/partner/vendor-orders',
}